import { useTranslation } from "react-i18next";
import { Shield, RefreshCw } from "lucide-react";

export const TrustIndicators = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center max-w-4xl mx-auto py-12">
      {/* Stripe Security Badge */}
      <div className="flex items-center gap-3 px-6 py-4 bg-muted/50 rounded-lg border">
        <Shield className="w-8 h-8 text-primary shrink-0" />
        <div>
          <p className="font-semibold text-sm flex items-center gap-2">
            {t('pricing.security.securePayment')}
            <svg className="h-5 w-auto" viewBox="0 0 60 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M59.64 14.28h-8.06c.19 1.93 1.6 2.55 3.2 2.55 1.64 0 2.96-.37 4.05-.95v3.32a8.33 8.33 0 01-4.56 1.1c-4.01 0-6.83-2.5-6.83-7.48 0-4.19 2.39-7.52 6.3-7.52 3.92 0 5.96 3.28 5.96 7.5 0 .4-.04 1.26-.06 1.48zm-5.92-5.62c-1.03 0-2.17.73-2.17 2.58h4.25c0-1.85-1.07-2.58-2.08-2.58zM40.95 20.3c-1.44 0-2.32-.6-2.9-1.04l-.02 4.63-4.12.87V5.57h3.76l.08.87c.75-.64 1.96-1.1 3.32-1.1 2.65 0 5.18 1.61 5.18 7.1 0 5.94-2.49 7.85-5.3 7.85zm-1.13-9.88c-.84 0-1.74.28-2.09.63v5.55c.4.35 1.2.6 1.96.6 1.63 0 2.66-1.31 2.66-3.41 0-2.08-1.03-3.37-2.53-3.37zM28.24 5.57h4.13v14.44h-4.13V5.57zm0-4.7L32.37 0v3.36l-4.13.88V.88zm-4.32 9.35v9.79H19.8V5.57h3.7l.12 1.22c1-1.77 3.07-1.41 3.62-1.22v3.79c-.52-.17-2.29-.43-3.32.86zm-8.55 4.72c0 2.43 2.6 1.68 3.12 1.46v3.36c-.55.3-1.54.54-2.89.54a4.15 4.15 0 01-4.27-4.24l.01-13.17 4.02-.86v3.54h3.14V9.1h-3.13v5.85zm-4.91.7c0 2.97-2.31 4.66-5.73 4.66a11.2 11.2 0 01-4.46-.93v-3.93c1.38.75 3.1 1.31 4.46 1.31.92 0 1.53-.24 1.53-1C6.26 13.77 0 14.51 0 9.95 0 7.04 2.28 5.3 5.62 5.3c1.36 0 2.72.2 4.09.75v3.88a9.23 9.23 0 00-4.1-1.06c-.86 0-1.44.25-1.44.9 0 1.85 6.29.97 6.29 5.88z" fill="#6772E5"/>
            </svg>
          </p>
          <p className="text-xs text-muted-foreground">
            {t('pricing.security.securePaymentDescription')}
          </p>
        </div>
      </div>

      {/* Money-Back Guarantee */}
      <div className="flex items-center gap-3 px-6 py-4 bg-muted/50 rounded-lg border">
        <RefreshCw className="w-8 h-8 text-primary shrink-0" />
        <div>
          <p className="font-semibold text-sm">
            {t('pricing.security.moneyBackGuarantee')}
          </p>
          <p className="text-xs text-muted-foreground">
            {t('pricing.security.moneyBackDescription')}
          </p>
        </div>
      </div>
    </div>
  );
};
